import { useContext, useEffect, useState } from "react"
import { AppContext } from "../App"
import { getInlineLoader } from "../Helpers"
import CategoryHero from "../ones/CategoryHero"
import Footer from "../ones/Footer"
import OneStory from "../ones/OneStory"

export default function StoriesLanding() {

  const appContext = useContext(AppContext);
  const [ready, setReady] = useState(false);

  async function init() {
    setReady(false);
    await Promise.all([
      appContext.getAllStories(),
    ])
    setReady(true);
  }

  useEffect(() => {
    init();
  }, [])

  if (ready) {
    const records = appContext.allStories || [];

    return (
      <>
        <CategoryHero
          eyebrow="MIKA KENYATA STORIES"
          title="Stories worth following."
          description="Explore published stories before choosing what to unlock."
        />

        <div className="container marketplace-page-container">
          <h6 className="main-section-title">Stories</h6>
          <div className="row g-4">
            {
              records.length > 0 ?
                records.map((item) => {
                  return (
                    <div className="col-12 col-sm-6 col-lg-4" key={item.uuid}>
                      <OneStory data={item} />
                    </div>
                  )
                })
                :
                <div className="col-12">
                  <div className="marketplace-empty-state">No stories were found</div>
                </div>
            }
          </div>
        </div>

        <Footer />
      </>
    )
  }

  return <div className="container mSupportLoading">{getInlineLoader()}</div>;
}
